/**
 * @generated SignedSource<<fc8b6ac37d1b76e2927ea070192843b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useEventVisibilityToggleMutation$variables = {
  guid: string;
};
export type useEventVisibilityToggleMutation$data = {
  readonly hideEvent: {
    readonly ok: boolean | null;
  } | null;
};
export type useEventVisibilityToggleMutation = {
  response: useEventVisibilityToggleMutation$data;
  variables: useEventVisibilityToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "guid",
        "variableName": "guid"
      }
    ],
    "concreteType": "HideEventMutation",
    "kind": "LinkedField",
    "name": "hideEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEventVisibilityToggleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEventVisibilityToggleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "868568441076df7e956bb37cb8e9fec8",
    "id": null,
    "metadata": {},
    "name": "useEventVisibilityToggleMutation",
    "operationKind": "mutation",
    "text": "mutation useEventVisibilityToggleMutation(\n  $guid: String!\n) {\n  hideEvent(guid: $guid) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "a36fe4f977de1ccd6d43a09b0218f792";

export default node;
